import { render } from "./PatientDiagnosis.vue?vue&type=template&id=67b09b25&scoped=true&ts=true"
import script from "./PatientDiagnosis.ts?vue&type=script&lang=ts&external"
export * from "./PatientDiagnosis.ts?vue&type=script&lang=ts&external"

import "./PatientDiagnosis.vue?vue&type=style&index=0&id=67b09b25&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b09b25"]])

export default __exports__